<div class="pop_up">
<h5>Declaration Message:</h5>
<div><p>I hereby declare that all above mentioned results are in accordance with fact, logic and truth up to my knowledge and I bear the responsibilities for the correctness of the above mentioned particulars.</p></div>
<button mat-raised-button class="pull-left" color="primary" (click)="proceed()" [disabled]="chkev">{{sessionTxt}}</button>
<button mat-raised-button class="pull-right" color="warn" (click)="cancel()" [disabled]="chkev">Deny</button>
</div>


